import * as RestaurantDetailActions from "../actions/restaurantDetails";

const initialState = {
  id: null,
  name: "",
  poolSchedule: [],
  editedPoolSchedule: [],
  pool: null,
  url: "",
  status: null,
  partnerSubscriptions: [],

  isEditing: false,
  isLoading: false,
  isSaving: false,
  loadError: null,
  updateError: null,

  logs: {
    data: [],
    totalItems: 0,
    itemsPerPage: 25,
  },

  summary: {
    eventCount: "",
    bestGuessReceived: "",
    bestGuess: "",
    graphData: [],
    isLoading: true,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RestaurantDetailActions.LOAD_RESTAURANT_REQUESTED:
      return {
        ...initialState,
        id: action.id,
        isLoading: true,
      };

    case RestaurantDetailActions.LOAD_RESTAURANT:
      // dont care if we finish loading a restaruant we are no longer requesting
      if (action.id !== state.id) return state;

      return {
        ...state,
        name: action.data.name,
        url: action.data.url,
        pool: action.data.pool,
        poolSchedule: action.data.poolSchedule,
        editedPoolSchedule: action.data.poolSchedule,
        status: action.data.status,
        partnerSubscriptions: action.data.partnerSubscriptions,
        isEditing: false,
        isSaving: false,
        isLoading: false,
        loadError: null,
        updateError: null,
      };

    case RestaurantDetailActions.LOAD_RESTAURANT_ERROR:
      // dont care if we finish loading a restaruant we are no longer requesting
      if (action.id !== state.id) return state;

      return {
        ...state,
        loadError: action.error,
        isLoading: false,
      };

    case RestaurantDetailActions.UPDATE_RESTAURANTPOOL_REQUESTED:
      // dont care if we are not updating the current restaurant
      if (action.id !== state.id) return state;

      return {
        ...state,
        updateError: null,
        isSaving: true,
      };

    case RestaurantDetailActions.UPDATE_RESTAURANTPOOL:
      // dont care if we are not updating the current restaurant
      if (action.id !== state.id) return state;

      return {
        ...state,
        poolSchedule: action.data.data,
        editedPoolSchedule: action.data.data,
        isEditing: false,
        isSaving: false,
        updateError: null,
      };

    case RestaurantDetailActions.UPDATE_RESTAURANTPOOL_ERROR:
      // dont care if we are not updating the current restaurant
      if (action.id !== state.id) return state;

      return {
        ...state,
        updateError: action.error,
        isSaving: false,
      };

    case RestaurantDetailActions.EDIT_RESTAURANTPOOL_STARTED:
      // dont care if we are not updating the current restaurant
      if (action.id !== state.id) return state;

      return {
        ...state,
        editedPoolSchedule: state.poolSchedule,
        isEditing: true,
      };

    case RestaurantDetailActions.EDIT_RESTAURANTPOOL_CANCELLED:
      // dont care if we are not updating the current restaurant
      if (action.id !== state.id) return state;

      return {
        ...state,
        editedPoolSchedule: state.poolSchedule,
        isEditing: false,
      };

    case RestaurantDetailActions.EDIT_RESTAURANTPOOL:
      // dont care if we are not updating the current restaurant
      if (action.id !== state.id) return state;
      if (!state.isEditing) return state;

      return {
        ...state,
        editedPoolSchedule: action.data.poolSchedule,
      };

    case RestaurantDetailActions.LOAD_RESTAURANTLOGS_REQUESTED:
      return {
        ...state,
        logs: {
          ...state.logs,
          data: [],
          totalItems: 0,
          isLoading: true,
        },
      };

    case RestaurantDetailActions.LOAD_RESTAURANTLOGS:
      return {
        ...state,
        logs: {
          ...state.logs,
          data: action.data.data,
          totalItems: action.data.totalItems,
          isLoading: false,
        },
      };

    case RestaurantDetailActions.LOAD_RESTAURANTLOGS_ERROR:
      return {
        ...state,
        logs: {
          ...state.logs,
          data: [],
          error: action.error,
          isLoading: false,
        },
      };

    case RestaurantDetailActions.LOAD_RESTAURANTSUMMARY_REQUESTED:
      return {
        ...state,
        summary: {
          ...state.summary,
          isLoading: true,
        },
      };

    case RestaurantDetailActions.LOAD_RESTAURANTSUMMARY:
      return {
        ...state,
        summary: {
          ...state.summary,
          eventCount: action.data.eventCount,
          bestGuessReceived: action.data.bestGuessReceived,
          bestGuess: action.data.bestGuess,
          graphData: action.data.graphData,
          isLoading: false,
        },
      };

    case RestaurantDetailActions.LOAD_RESTAURANTSUMMARY_ERROR:
      return {
        ...state,
        summary: {
          ...state.summary,
          error: action.error,
          isLoading: false,
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/restaurantDetails.js